import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql, QueryRenderer } from 'react-relay';
import { Flex, Box } from 'grid-styled';
import pure from 'recompose/pure';
import _map from 'lodash/map';
import { MuiButton } from '@onehope/design-system-ohw';

/* UI */
import { List, ListItem, makeSelectable } from 'material-ui/List';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

// import ShopLeftNavContent from '../../../../marketplace/components/_common/ShopLeftNav/ShopLeftNavContent';
// import { withShopToggle } from '../../../../marketplace/components/_common/_hoc/ShopToggle';
// import { withMenuToggle } from '../../../../marketplace/components/_common/_hoc/MenuToggle';

/* Helpers */
import { ROLES } from '../../../../server/config';
import { tablet, mobile } from './../../../utils/deviceWidths';
import { getCategory } from '../../App/AppHelpers';
import { customPCPConfig } from '../../../../server/utils/customPCPConfig';
import { shopNavConfig } from '../../../utils/shopNavConfig';
import { resetSegment } from '../../../utils/tracking';
import reassignLocation from '../../../utils/reassignLocation';

/* Style */
import {
  listStyles,
  nestedListStyles,
  dividerStyle,
  arrowToggleColor,
  arrowToggleDownColor,
  containerStyle,
  smallContainerStyle,
  listHeaderStyle,
  listSubHeaderStyle,
  visibleToastStyle,
} from './ShopLeftNav.styles';

import './ShopLeftNav.scss';
import { urlCeHome } from '../../../../server/utils/routeConstants';

const SelectableList = makeSelectable(List);

const propTypes = {
  viewer: PropTypes.object.isRequired,
  shopNavOpen: PropTypes.bool.isRequired,
  isVisibleToast: PropTypes.bool.isRequired,
  handleLogout: PropTypes.func.isRequired,
  shopNavState: PropTypes.object.isRequired,
  toggleListItem: PropTypes.func.isRequired,
  closeAllListItems: PropTypes.func.isRequired,
  handleShopClose: PropTypes.func.isRequired,
  handleCartClose: PropTypes.func.isRequired,
  handleShopToggle: PropTypes.func.isRequired,
  containerWidth: PropTypes.number.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  hasNavStateChanged: PropTypes.bool.isRequired,
  handleRouteStaticRoute: PropTypes.func.isRequired,
};

// const ShopLeftNavContentWithMenuAndShopToggle = withMenuToggle(
//   withShopToggle(ShopLeftNavContent),
// );

class ShopLeftNavComponent extends Component {
  constructor() {
    super();

    this.state = {
      hasChanged: false,
    };
  }

  getNavWidth = (containerWidth, isShop) => {
    switch (true) {
      case containerWidth <= mobile:
        return containerWidth;
      case containerWidth > tablet && isShop:
        return 250;
      default:
      case containerWidth <= tablet:
      case containerWidth > tablet && !isShop:
        return 400;
    }
  };

  handleMenuLinkSelection = (e, value) => {
    if (!value) return;
    const {
      handleRouteChange,
      handleRouteStaticRoute,
      containerWidth,
      handleShopClose,
      shopNavOpen,
      location,
    } = this.props;
    this.handleChange();
    if (value === 'signout') {
      this.userLogout();
    } else if (Array.isArray(value.match('shop')) && shopNavOpen) {
      const route = value.match(/([^\/]*)\/*$/)[1];
      const isCustomPage = customPCPConfig[route];
      const category = isCustomPage
        ? isCustomPage.category
        : getCategory(value);
      const customRoute = isCustomPage ? route : null;
      // Leaving this in here temporarily in case we roll back...
      if (value.includes('events') || value.includes('customers')) {
        reassignLocation(value, handleRouteChange);
      } else {
        handleRouteChange(e, value, category, customRoute);
      }
    } else if (value === urlCeHome) {
      // Open CE Dash in same window even though it is a static route
      reassignLocation(value, handleRouteChange);
    } else if (value.includes('https://')) {
      window.location.href = value;
    } else if (value.includes('#')) {
      handleRouteStaticRoute(value, null, true);
    } else {
      handleRouteStaticRoute(value);
    }
    if (containerWidth <= tablet) handleShopClose();
  };

  userLogout = () => {
    const { handleLogout } = this.props;
    const onCompleted = () => {
      resetSegment();
    };
    return handleLogout(onCompleted);
  };

  toggleList = item => {
    switch (item) {
      default:
      case 'listItemWine':
        return this.toggleWines;
      case 'listItemGifts':
        return this.toggleGifts;
      case 'listItemCoffee':
        return this.toggleCoffee;
      case 'listItemOnehope':
        return this.toggleOneHope;
      case 'listItemCollection':
        return this.toggleCollections;
      case 'listItemKitchen':
        return this.toggleKitchen;
      case 'listItemGuides':
        return this.toggleGuides;
      case 'listItemTea':
        return this.toggleTea;
    }
  };

  toggleAccounts = () => {
    const {
      toggleListItem,
      viewer: { user },
    } = this.props;
    const { myAccountText } = this.state;
    const { firstName } = user;
    toggleListItem('account');
    if (myAccountText === 'My Account') {
      this.setAccountText(`Hi, ${firstName}!`);
    } else {
      this.setAccountText(`My Account`);
    }
    this.handleChange();
  };

  setAccountText = text => {
    this.setState({ myAccountText: text });
  };

  toggleWines = () => {
    const { toggleListItem } = this.props;
    toggleListItem('wine');
    this.handleChange();
  };

  toggleCoffee = () => {
    const { toggleListItem } = this.props;
    toggleListItem('coffee');
    this.handleChange();
  };

  toggleGifts = () => {
    const { toggleListItem } = this.props;
    toggleListItem('gift');
    this.handleChange();
  };

  toggleKitchen = () => {
    const { toggleListItem } = this.props;
    toggleListItem('kitchen');
    this.handleChange();
  };

  toggleOneHope = () => {
    const { toggleListItem } = this.props;
    toggleListItem('onehope');
    this.handleChange();
  };

  toggleCollections = () => {
    const { toggleListItem } = this.props;
    toggleListItem('collection');
    this.handleChange();
  };

  toggleGuides = () => {
    const { toggleListItem } = this.props;
    toggleListItem('guide');
    this.handleChange();
  };

  // toggleTea = () => {
  //   const { toggleListItem } = this.props;
  //   toggleListItem('tea');
  //   this.handleChange();
  // };

  closeLists = () => {
    const { closeAllListItems } = this.props;
    closeAllListItems();
    this.handleChange();
  };

  handleLogin = e => {
    e.preventDefault();
    const { handleRouteChange } = this.props;
    const redirectUrl = encodeURI(window.location.href);
    if (!window.location.pathname.includes('login')) {
      handleRouteChange(e, `/login?redirect_uri=${redirectUrl}`);
    }
  };

  handleClickSameCategory = e => {
    const value = e.currentTarget.getAttribute('value');
    const { location, handleShopClose, containerWidth } = this.props;
    if (value === location && containerWidth <= tablet) {
      return handleShopClose();
    }
  };

  handleChange = () => {
    this.setState(prevState => ({
      hasChanged: !prevState.hasChanged,
    }));
  };

  getAccountMenu = () => {
    const {
      viewer,
      containerWidth,
      handleShopClose,
      handleRouteChange,
      shopNavState,
      handleAuthentication,
    } = this.props;
    const { listItemAccount } = shopNavState;
    const {
      user,
      user: { role, permissions },
    } = viewer;

    const ceoAdminText = 'CE Dashboard';
    // const ceBackOfficeText = 'CE Backoffice';
    // const trainingCenterText = 'Training Center';
    // const resourcesText = 'Resources';

    const myAccountText = 'Account';
    const myProfileText = 'Profile';
    const myOrdersText = 'Orders';
    const myAddressesText = 'Addresses';
    const myPaymentsText = 'Payments';
    const myFavoritesText = 'My Favorites';
    const myGrapefulText = 'Subscriptions';
    const signoutText = 'Log Out';
    const isCeo = permissions && permissions.oneCommerce.ceo.access;

    const listItems = [
      <ListItem
        key="account"
        {...listStyles}
        primaryText={myProfileText}
        value="/account"
      />,
      <ListItem
        key="favorites"
        {...listStyles}
        primaryText={myFavoritesText}
        value="/account/favorites"
      />,
      <ListItem
        key="grapefulClub"
        {...listStyles}
        primaryText={myGrapefulText}
        value="/account/subscriptions"
      />,
      <ListItem
        key="orders"
        {...listStyles}
        primaryText={myOrdersText}
        value="/account/orders"
      />,
      <ListItem
        key="addresses"
        {...listStyles}
        primaryText={myAddressesText}
        value="/account/addresses"
      />,
      <ListItem
        key="payments"
        {...listStyles}
        primaryText={myPaymentsText}
        value="/account/payments"
      />,
      <ListItem
        key="signout"
        {...listStyles}
        primaryText={signoutText}
        value="signout"
      />,
    ];

    if (isCeo) {
      listItems.unshift(
        <ListItem
          key="ce"
          {...listStyles}
          primaryText={ceoAdminText}
          value={urlCeHome}
        />,
        // <ListItem
        //   key="backoffice"
        //   {...listStyles}
        //   primaryText={ceBackOfficeText}
        //   value={urlTrinityBackoffice}
        // />,
        // <ListItem
        //   key="learningCenter"
        //   {...listStyles}
        //   primaryText={trainingCenterText}
        //   value="https://onehopewine.app.workramp.com/login"
        // />,
        // <ListItem
        //   key="resources"
        //   {...listStyles}
        //   primaryText={resourcesText}
        //   value="http://knowledge.onehopewine.com/resource-center-overview"
        // />,
      );
    }

    const isLoggedIn = role !== ROLES.anonymous;
    const listItemAccountIcon = listItemAccount ? (
      <ArrowUp color={arrowToggleColor} />
    ) : (
      <ArrowDown color={arrowToggleDownColor} />
    );

    if (isLoggedIn) {
      return (
        <ListItem
          style={listHeaderStyle}
          primaryText={myAccountText}
          initiallyOpen={false}
          open={listItemAccount}
          onNestedListToggle={this.toggleAccounts}
          primaryTogglesNestedList
          rightIcon={listItemAccountIcon}
          nestedItems={listItems}
        />
      );
    }

    const logInText = 'Sign In';
    return (
      <div className="ShopLeftNav__login">
        <MuiButton fullWidth type="PRIMARY" onClick={this.handleLogin}>
          {logInText}
        </MuiButton>
      </div>
    );
  };

  render() {
    if (!this.props.viewer || !this.props.viewer.user) {
      return <div />;
    }
    const {
      shopNavOpen,
      containerWidth,
      handleShopClose,
      viewer,
      location,
      shopNavState,
      isVisibleToast,
    } = this.props;
    const {
      user: { permissions },
    } = viewer;
    const isLoggedIn = viewer.user.role !== ROLES.anonymous;
    const isTablet = containerWidth <= tablet;
    const isDesktop = containerWidth > tablet;
    const isCeo = permissions && permissions.oneCommerce.ceo.access;
    const isShop = Array.isArray(location.match('shop'));
    let drawerContainerStyle;
    if (containerWidth > tablet && isShop) {
      drawerContainerStyle = containerStyle;
      // Toast is full length in desktop so could cover the menu.
      if (isVisibleToast) {
        drawerContainerStyle = {
          ...drawerContainerStyle,
          ...visibleToastStyle,
        };
      }
    } else {
      drawerContainerStyle = smallContainerStyle;
    }
    return (
      <Drawer
        width={this.getNavWidth(containerWidth, isShop)}
        openRight={false}
        open={shopNavOpen}
        disableSwipeToOpen
        docked={isDesktop && isShop}
        overlayStyle={{ zIndex: 3000 }}
        containerStyle={drawerContainerStyle}
        onRequestChange={handleShopClose}
      >
        {(isTablet || !isShop) && (
          <Box w={[1]} className="ShopLeftNav">
            <Flex justify="flex-end" align="center">
              <Box>
                <IconButton onClick={handleShopClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Flex>
          </Box>
        )}
        <SelectableList
          value={location}
          onChange={this.handleMenuLinkSelection}
        >
          {isLoggedIn && isTablet && <Divider style={dividerStyle} />}

          {isCeo && isTablet && this.getAccountMenu()}

          {_map(shopNavConfig, listItem => (
            <ListItem
              key={listItem.primaryTitle}
              className={listItem.className}
              open={shopNavState[listItem.open]}
              primaryText={listItem.primaryTitle}
              initiallyOpen={listItem.initiallyOpen}
              onNestedListToggle={
                listItem.nestedItems.length
                  ? this.toggleList(listItem.open)
                  : this.closeLists
              }
              value={listItem.route}
              primaryTogglesNestedList
              style={listHeaderStyle}
              nestedListStyle={{ borderBottom: '1px solid #ddd' }}
              rightIcon={
                listItem.nestedItems.length ? (
                  shopNavState[listItem.open] ? (
                    <ArrowUp color={arrowToggleColor} />
                  ) : (
                    <ArrowDown color={arrowToggleDownColor} />
                  )
                ) : null
              }
              nestedItems={_map(listItem.nestedItems, item =>
                item.nestedItems ? (
                  <ListItem
                    key={item.primaryTitle}
                    open={shopNavState[item.open]}
                    primaryText={item.primaryTitle}
                    initiallyOpen={item.initiallyOpen}
                    onNestedListToggle={this.toggleList(item.open)}
                    primaryTogglesNestedList
                    style={listSubHeaderStyle}
                    rightIcon={
                      shopNavState[item.open] ? (
                        <ArrowUp color={arrowToggleColor} />
                      ) : (
                        <ArrowDown color={arrowToggleDownColor} />
                      )
                    }
                    nestedItems={_map(item.nestedItems, i => (
                      <ListItem
                        {...nestedListStyles}
                        onClick={this.handleClickSameCategory}
                        key={i.route}
                        value={i.route}
                        primaryText={i.title}
                        className={i.className}
                      />
                    ))}
                  />
                ) : (
                  <ListItem
                    {...listStyles}
                    key={item.route}
                    value={item.route}
                    primaryText={item.title}
                    className={item.className}
                    onClick={this.handleClickSameCategory}
                  />
                ),
              )}
            />
          ))}

          {!isCeo && isTablet && this.getAccountMenu()}
        </SelectableList>
      </Drawer>
    );
  }
}

ShopLeftNavComponent.propTypes = propTypes;

const LeftNavFragmentComponent = createFragmentContainer(ShopLeftNavComponent, {
  viewer: graphql`
    fragment ShopLeftNavComponent_viewer on Viewer {
      user {
        id
        id
        email
        firstName
        lastName
        role
        accountRole {
          accountRoleTitle
        }
        permissions {
          id
          oneCommerce {
            id
            ceo {
              access
            }
          }
        }
      }
    }
  `,
});

const noVariables = {};

// eslint-disable-next-line react/display-name
export default ({ environment, ...props }) => {
  return (
    <QueryRenderer
      variables={noVariables}
      environment={environment}
      query={graphql`
        query ShopLeftNavComponentQuery {
          viewer {
            id
            id
            ...ShopLeftNavComponent_viewer
          }
        }
      `}
      render={({ error, props: propsFromRender }) => {
        if (error) {
          return <div />;
        }
        if (propsFromRender && propsFromRender.viewer) {
          return (
            <LeftNavFragmentComponent
              {...props}
              viewer={propsFromRender.viewer}
            />
          );
        }
      }}
    />
  );
};
